export const TICKER_PREFETCH_SIZE = '5';
export const TICKER_SCROLL_SIZE = '100';
export const TICKER_MATCH_CARD_WIDTH = 324;
export const HOMEPAGE_COLUMN_NUMBER_OF_WIDGETS = 10;
export const MATCH_CARDS_BUCKET_PATH = 'matchcards';
export const COURT_PRIORITY = [
  'cc',
  'incc',
  's',
  'gs',
  'sc',
  's1',
  'gs1',
  'sc1',
  's2',
  'gs2',
  'sc2',
  's3',
  'gs3',
  'sc3',
  's4',
  'gs4',
  'sc4',
  's5',
  'gs5',
  'sc5',
  's6',
  'gs6',
  'sc6',
];

export const SITEMAP_PAGINATION_PAGE_SIZE = 45000;

export const USER_IMPRESSION_KEY = 'user-impression-key';
export const BLOG_LABEL = 'Pickleball Hub';
export const GOOGLE_AUTOCOMPLETE_SCRIPT_ID = 'google-script';
export const TINYMCE_EDITOR_KEY = '2fhjogepu3pkb5q18hb6hzxgg2ojov07jq1mukahjnp7y0my';
export const GOOGLE_ADS_SCRIPT_SRC =
  'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7705270835238428';

export const IS_PRODUCTION = process.env.NEXT_PUBLIC_APP_ENV === 'prod';
export const IS_DEVELOPMENT = process.env.NEXT_PUBLIC_APP_ENV === 'dev';

export const PICKLEBALL_PLACEHOLDER_IMAGE = `${process.env.NEXT_PUBLIC_IMAGE_CDN}/global/PB-gray.svg`;
export const CLUBS_PLACEHOLDER_IMAGE = `${process.env.NEXT_PUBLIC_IMAGE_CDN}/global/PC-gray.svg`;
export const LEAGUES_PLACEHOLDER_IMAGE = `${process.env.NEXT_PUBLIC_IMAGE_CDN}/global/PL-gray.svg`;
export const TOURNAMENT_PLACEHOLDER_IMAGE = `${process.env.NEXT_PUBLIC_IMAGE_CDN}/global/PT-gray.svg`;
export const TEAM_LEAGUES_PLACEHOLDER_IMAGE = `${process.env.NEXT_PUBLIC_IMAGE_CDN}/global/PTL-gray.svg`;
export const WPR_PLACEHOLDER_IMAGE = `${process.env.NEXT_PUBLIC_IMAGE_CDN}/global/WPR-gray.svg`;

export const FEATURED_PLAYERS_SINGLES = 'Singles';

export const ALLOWED_ORIGINS = [
  'http://localhost',
  'https://pickleball.com',
  'https://www.pickleball.com',
  'https://sso.pickleball.com',
  'https://www.sso.pickleball.com',
  'https://manage.pickleball.com',
  'https://www.manage.pickleball.com',
  'https://checkout.pickleball', // Sufficient, since it can be pickleball.com, pickleballclubs.com, pickleballtournaments.com, pickleballteamleagues.com and more (in all cases pickleball is the first word of the domain)
  'https://www.checkout.pickleball',
  'https://pickleballleagues.com',
  'https://www.pickleballleagues.com',
  'https://worldpickleballrankings.com',
  'https://www.worldpickleballrankings.com',
  'https://pickleballtournaments.com',
  'https://www.pickleballtournaments.com',
  'https://pickleballclubs.com',
  'https://www.pickleballclubs.com',
  'https://pickleballteamleagues.com',
  'https://www.pickleballteamleagues.com',
  'https://pickleballdev.net',
  'https://www.pickleballdev.net',
  'https://sso.pickleballdev.net',
  'https://www.sso.pickleballdev.net',
  'https://manage.pickleballdev.net',
  'https://www.manage.pickleballdev.net',
  'https://pickleballleaguesdev.net',
  'https://www.pickleballleaguesdev.net',
  'https://worldpickleballrankingsdev.net',
  'https://www.worldpickleballrankingsdev.net',
  'https://pickleballtournamentsdev.net',
  'https://www.pickleballtournamentsdev.net',
  'https://pickleballclubsdev.net',
  'https://www.pickleballclubsdev.net',
  'https://pickleballteamleaguesdev.net',
  'https://www.pickleballteamleaguesdev.net',
];

export const PBRACKETS_UPLOADS_ROOT = `${process.env.NEXT_PUBLIC_PBRACKETS_IMAGE_URL}/uploads`;

const MLP_ORG_UUID_PROD = 'f6f5296b-b9a6-4d25-a295-29f461de56d2';
const MLP_TL_UUID_PROD = '2f129d1d-0202-4d55-8448-bfafc0872305';
const MLP_TL_SLUG_PROD = 'major-league-pickleball';
const MLP_ORG_UUID_DEV = 'c1e16af8-4b0e-456d-a8a8-d0fe1d5d630c';
const MLP_TL_UUID_DEV = '4e239924-3cba-4ce9-a996-26925ef940d1';
const MLP_TL_SLUG_DEV = 'test_league_mlp';

export const MLP_ORG_UUID = IS_PRODUCTION ? MLP_ORG_UUID_PROD : MLP_ORG_UUID_DEV;
export const MLP_TL_UUID = IS_PRODUCTION ? MLP_TL_UUID_PROD : MLP_TL_UUID_DEV;
export const MLP_TL_SLUG = IS_PRODUCTION ? MLP_TL_SLUG_PROD : MLP_TL_SLUG_DEV;

// Left for future testing team league that has matchups with multiple pods
// const NPL_ORG_UUID_PROD = '88b1bbcd-7a65-4823-8e2c-5f5fc0c026e0';
// const NPL_TL_UUID_PROD = 'c420f83a-b066-4356-bbeb-894590dc0e84';
// const NPL_ORG_UUID_DEV = '4d060010-2541-45af-8100-7432c37c5875';
// const NPL_TL_UUID_DEV = '657a7b45-4b34-4c7b-9fb2-a986a2177da8';

// export const NPL_ORG_UUID = IS_PRODUCTION ? NPL_ORG_UUID_PROD : NPL_ORG_UUID_DEV;
// export const NPL_TL_UUID = IS_PRODUCTION ? NPL_TL_UUID_PROD : NPL_TL_UUID_DEV;

export const GTM_ID_PBCOM = 'GTM-NSBB9F4L';
export const MS_CLARITY_ID_PBCOM = 'rcs6udt4io';

export const WHITE_LISTED_PAGES = ['/players', '/results', '/leagues'];
export const FRESHDESK_CHAT_BOT_TOKEN = 'd0a37f09-4ea6-4fdd-b698-e44d1308f2b6';
export const FRESHDESK_CHAT_BOT_HOST = 'https://pickleball.freshchat.com';
export const FRESHDESK_SCRIPT_ID = 'Freshchat-js-sdk';
export const FRESHDESK_SCRIPT_SRC = 'https://pickleball.freshchat.com/js/widget.js';
export const FRESHDESK_WIDGET_UUID = '0796eb5d-c0cb-4368-a474-bf3fbf0f9fae';
export const FRESHDESK_LEAGUES_WIDGET_UUID = '995c1b3e-ff0f-43bb-89e9-2145b61b2415';
